module.exports = __webpack_public_path__ + "static/img/ceshi.b6daddda.jpg";